import type { VisitorSummary } from '@livechat/shared';

export function visitorLocationLabel(
	visitor: Pick<VisitorSummary, 'cityName' | 'countryName'>,
): string {
	return (
		[visitor.countryName, visitor.cityName].filter(Boolean).join(' · ') ||
		'Location unavailable'
	);
}

function UnknownLocationIcon() {
	return (
		<svg aria-hidden="true" className="location-unknown-icon" fill="none" viewBox="0 0 24 24">
			<circle cx="12" cy="12" r="8.5" />
			<path d="M12 7.4v5.1" />
			<path d="M12 16.6h.01" />
		</svg>
	);
}

export function CountryFlag({ countryCode }: { countryCode?: string }) {
	const normalisedCode = countryCode?.trim().toLowerCase();
	if (!normalisedCode || !/^[a-z]{2}$/.test(normalisedCode)) {
		return <UnknownLocationIcon />;
	}
	return <span aria-hidden="true" className={`country-flag fi fi-${normalisedCode}`} />;
}
